export const accessUserRoles = [
	{
		value: "editor",
		label: "Listing editor",
		description:
			"Editors can only make changes to listings that they have been given access to. They can't view reports, billing information or invite users."
	},
	{
		value: "vacancy-editor",
		label: "Vacancy editor",
		description:
			"Vacancy editors can view and update vacancies for the selected listings."
	}
];

export const connectUserRoles = [
	{
		type: "connect-team-leader",
		label: "Team Leader",
		description:
			"Team leaders can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billling information or invite users."
	},
	{
		type: "connect-case-manager",
		label: "Team Member",
		description:
			"Team members can search, save shortlists, send enquiries and view reports only on their activity. They can't view billing information or invite users"
	},
	{
		type: "care-coordinator",
		label: "Care Coordinator",
		description:
			"Care Coordinators can search, save shortlists, send enquiries and view reports on their team's activity. They can't view billing information or invite users"
	}
];

export const dailyDataUserRoles = [
	{
		type: "dailydata-general",
		label: "DailyData user",
		description: null
	}
];

export default {
	email: "",
	dashboards: [],
	firstname: "",
	image: "",
	jobtitle: "",
	lastname: "",
	mobile: "",
	pagernumber: "",
	phone: "",
	phoneisdirect: false,
	status: "non-active",
	role: "editor"
};
